module.exports = __webpack_public_path__ + "img/contacts_social_instagram.022fa0ec.svg";